<template>
  <div>
    <Card>
      <TablePaginate :columns="columns" :data="shops" :loading="loading" :meta="meta" :changePage="changePage">
      </TablePaginate>
    </Card>
    <!-- <Modal v-model="modalShow2"
           @on-ok="handleSubmit"
           title="激活码">
      <Form ref="shop"
            :model="shop"
            :label-width="120">
        <Form-item label="输入激活码"
                   prop="activation_code">
          <Input type="text"
                 v-model="shop.activation_code" />
        </Form-item>
      </Form>
    </Modal> -->
    <Modal v-model="modalShow" :loading="shopUpdateLoading" @on-ok="handleShopUpdate" :title="$t('pages_shops_index_1060')">
      <Form ref="shopUpdate" :model="shop" :label-width="120" :rules="updateRules">
        <Form-item :label="$t('pages_lcsw_accounts_index_512')" prop="name">
          <Input type="text" :placeholder="$t('pages_product_stocks_index_739')" v-model="shop.name" />
        </Form-item>
        <Form-Item :label="$t('pages_shops_index_1061')" prop="avatar" class="shop_avatar">
          <uploader @uploadedUrl="uploadedAvatar" :url="shop.avatar"></uploader>
          <span>{{$t('pages_shops_index_1062')}}</span>
        </Form-Item>
        <Form-item :label="$t('pages_shops_index_1063')" prop="bulletin">
          <Input type="text" :placeholder="$t('pages_shops_index_1064')" v-model="shop.bulletin" />
        </Form-item>
        <Form-item :label="$t('pages_shops_index_1065')" prop="shop_type">
          <Select v-model="shop.shop_type">
            <Option v-for="(item, index) in industrys" :key="index" :value="item.value">{{ item.name }}</Option>
          </Select>
        </Form-item>
        <template v-if="shop.shop_type === 'chinese'">
          <Form-item :label="$t('pages_shops_index_1066')" prop="order_mode">
            <Select v-model="shop.order_mode">
              <Option v-for="(item, index) in orderModes" :key="index" :value="item.value">{{ item.name }}</Option>
            </Select>
          </Form-item>
          <Form-item :label="$t('pages_shops_index_1067')" prop="desk_payment_mode">
            <Select v-model="shop.desk_payment_mode">
              <Option v-for="(item, index) in deskPaymentModes" :key="index" :value="item.value">{{ item.name }}</Option>
            </Select>
          </Form-item>
          <Form-item :label="$t('pages_shops_index_1068')" prop="pickup_payment_mode">
            <Select v-model="shop.pickup_payment_mode">
              <Option v-for="(item, index) in pickupPaymentMode" :key="index" :value="item.value">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </template>
        <Form-item :label="$t('pages_shops_index_1069')" prop="country">
          <Select v-model="shop.country">
            <Option v-for="(item, index) in countries" :key="index" :value="item.code">{{ item.name }}</Option>
          </Select>
        </Form-item>
        <template v-if="shop.country === $t('libs_value_list_121')">
          <Form-item :label="$t('pages_lcsw_accounts_index_515')" prop="province_zip_code">
            <Select v-model="shop.province_zip_code" @on-change="onProvinceChange">
              <Option v-for="(item, index) in provinces" :key="index" :value="item.zip_code">{{ item.name }}</Option>
            </Select>
          </Form-item>
          <Form-item :label="$t('pages_lcsw_accounts_index_516')" prop="city_zip_code">
            <Select v-model="shop.city_zip_code" @on-change="onCityChange">
              <Option v-for="item in cities" :key="item.zip_code" :value="item.zip_code">{{ item.name }}</Option>
            </Select>
          </Form-item>
          <Form-item :label="$t('pages_lcsw_accounts_index_517')" prop="district_zip_code">
            <Select v-model="shop.district_zip_code">
              <Option v-for="item in districts" :key="item.zip_code" :value="item.zip_code">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </template>
        <Form-item :label="$t('pages_shops_index_1070')" prop="address">
          <i-input v-model="shop.address" :placeholder="$t('pages_shops_index_1071')">
            <Button slot="append" @click="getLatlng">{{$t('pages_shops_index_1072')}}</Button>
          </i-input>
        </Form-item>
        <Form-item :label="$t('pages_settings_take_out_1050')" prop="longitude">
          <Input v-model="shop.longitude" type="number" :placeholder="$t('pages_shops_index_1073')" />
        </Form-item>
        <Form-item :label="$t('pages_settings_take_out_1052')" prop="latitude">
          <Input v-model="shop.latitude" type="number" :placeholder="$t('pages_shops_index_1074')" />
        </Form-item>
      </Form>
    </Modal>
    <Modal v-model="show_mini_code_url" style="width: 500px" :title="mini_code_type === 'weapp' ? $t('pages_shops_index_1075') : $t('pages_shops_index_1076')">
      <el-switch v-if="mini_code_type === 'h5'"
        style="display: table; left: 50%; transform: translate(-50%); margin-bottom: 10px;" v-model="qrCodeTemplate"
        active-color="#409EFF" inactive-color="#409EFF" :active-text="$t('pages_shops_index_1077')" :inactive-text="$t('pages_shops_index_1078')">
      </el-switch>
      <template v-if="qrCodeUrl">
        <img :src="qrCodeUrl" style="width: auto; max-height: 600px; display: block; margin: 0 auto;" />
        <Button style="margin: 10px auto 0; display: inherit;" @click="downloadImg(qrCodeUrl)">{{$t('pages_shops_index_1079')}}</Button>
      </template>
      <span v-else>{{$t('pages_shops_index_1080')}}</span>
    </Modal>
    <Modal v-model="charegModalShow" :loading="chargeFormLoading" @on-ok="handleCharge" :title="$t('pages_shops_index_1081')">
      <Form ref="chargeForm" :model="chargeForm" :rules="chargeRules" :label-width="80">
        <Form-item :label="$t('pages_bills_index_202')" prop="sum">
          <Input v-model="chargeForm.sum" type="number" :placeholder="$t('pages_shops_index_1082')" />
        </Form-item>
      </Form>
    </Modal>
    <Modal v-model="buyableModalShow" :loading="shopBuyableLoading" @on-ok="handleBuyable" :title="$t('pages_shops_index_1083')">
      <Form ref="shopBuyable" :model="shopBuyable" :rules="buyableRules" :label-width="80">
        <Form-item :label="$t('pages_shops_index_1084')" prop="shopType">
          <Select v-model="shopBuyable.shopType" @on-change="handleChangeSoftware('type', $event)">
            <Option v-for="item in shopTypesList" :key="item.value" :value="item.value">{{ item.name }}</Option>
          </Select>
        </Form-item>
        <Form-item v-if="shopBuyable.shopType === 'FreshSoftwareVersion'" :label="$t('pages_shops_index_1085')" prop="shopVersion">
          <Select v-model="shopBuyable.shopVersion" @on-change="handleChangeSoftware('version', $event)">
            <Option v-for="item in shopVersionsList" :key="item.buyable_name" :value="item.id">{{ item.buyable_title }}
            </Option>
          </Select>
        </Form-item>
        <Form-item v-if="shopBuyable.shopType === 'FreshSoftwareFeature'" :label="$t('pages_shops_index_1086')" prop="shopFeature">
          <Select v-model="shopBuyable.shopFeature" @on-change="handleChangeSoftware('feature', $event)">
            <Option v-for="item in shopFeaturesList" :key="item.buyable_name" :value="item.id">{{ item.buyable_title }}
            </Option>
          </Select>
        </Form-item>
        <Form-item
          v-if="shopBuyable.shopType === 'FreshSoftwareVersion' && shopBuyable.shopVersion || shopBuyable.shopType === 'FreshSoftwareFeature' && shopBuyable.shopFeature">{{$t('pages_shops_index_1087', [ shopBuyable.quantity ])}}<br />{{$t('pages_shops_index_1088', [ shopBuyable.duration ])}}<br />{{$t('pages_shops_index_1089', [ shopBuyable.price ])}}</Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
import Uploader from '@/components/uploader-aliyun/single'
import TablePaginate from '@/components/TablePaginate'
import {
  commonButtonInTable,
  editorButtonInTable,
  commonButtonInTable2
} from '@/libs/table-render'
import { durationList, orderModes, industrys, deskPaymentModes, pickupPaymentMode } from '@/libs/value-list'
import { openUrlOnExternalBrowser, isAndroidApp } from "@/libs/android_jsbridge"
import { downloadImg } from "@/libs/util"
import { find } from 'lodash';

export default {
  components: {
    TablePaginate,
    Uploader
  },
  data() {
    const vm = this;
    return {
      orderModes,
      deskPaymentModes,
      pickupPaymentMode,
      industrys,
      modalShow: false,
      // modalShow2: false,
      current_shop_id: 0,
      mini_code_type: '',
      mini_code_url: '',
      mini_code_template_url: '',
      show_mini_code_url: false,
      qrCodeTemplate: false,
      shopUpdateLoading: true,
      updateRules: {
        name: { required: true, message: i18n.t('pages_product_stocks_index_739') },
        avatar: { required: true, message: i18n.t('pages_shops_index_1090') },
        bulletin: { required: true, message: i18n.t('pages_shops_index_1091') },
        // province_zip_code: [
        //   { required: true, message: '请选择省份' }
        // ],
        // city_zip_code: [
        //   { required: true, message: '请选择城市' }
        // ],
        // district_zip_code: [
        //   { required: true, message: '请选择区县/村' }
        // ],
      },
      columns: [
        {
          title: 'ID',
          key: 'id',
          width: 100
        },
        {
          title: i18n.t('pages_lcsw_accounts_index_553'),
          width: 200,
          key: 'name'
        },
        {
          title: i18n.t('pages_customers_index_337'),
          width: 100,
          key: 'balance'
        },
        {
          title: i18n.t('pages_lcsw_accounts_index_554'),
          width: 120,
          align: 'center',
          key: 'lcsw_account_status'
        },
        {
          title: i18n.t('pages_shops_index_1085'),
          width: 120,
          align: 'center',
          render: (h, params) => {
            return h(
              'div',
              (find(vm.fresh_software_versions, { name: params.row.software_version_name }) || {}).title || params.row.software_version_name
            )
          }
        },
        // {
        //   title: '激活时间',
        //   width: 200,
        //   align: 'center',
        //   key: 'activated_at_str'
        // },
        {
          title: i18n.t('pages_shops_index_1092'),
          width: 100,
          align: 'center',
          render(h, params) {
            const onclick = () => {
              vm.show_mini_code_url = true
              vm.mini_code_type = 'weapp'
              vm.mini_code_url = params.row.wechat_qr_code_url
            }
            return <a onClick={onclick}>查看</a>
          }
        },
        {
          title: i18n.t('pages_shops_index_1093'),
          width: 120,
          align: 'center',
          render(h, params) {
            const onclick = () => {
              vm.show_mini_code_url = true
              vm.mini_code_type = 'h5'
              vm.mini_code_url = params.row.quick_qr_code_url
              vm.mini_code_template_url = params.row.smart_qr_code_url
            }
            return <a onClick={onclick}>查看</a>
          }
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 350,
          fixed: 'right',
          render: (h, params) => {
            const children = []
            // children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            if (localStorage.getItem('SHOPID') !== params.row.id.toString()) {
              children.push(
                commonButtonInTable(
                  this,
                  h,
                  'warning',
                  i18n.t('pages_lcsw_accounts_index_555'),
                  this.shop_select,
                  [params.row]
                )
              )
            } else {
              children.push(
                commonButtonInTable2(
                  this,
                  h,
                  { type: 'error', disabled: true },
                  i18n.t('pages_shops_index_1094')
                )
              )
            }
            // if (params.row.software_version_name !== 'standard') {
            //   children.push(
            //     commonButtonInTable(
            //       this,
            //       h,
            //       'success',
            //       '升级标准版',
            //       this.shop_upgrade,
            //       [params.row.id]
            //     )
            //   )
            // } else {
            //   // children.push(
            //   //   commonButtonInTable(
            //   //     this,
            //   //     h,
            //   //     'error',
            //   //     '降为基础版',
            //   //     this.shop_reduce,
            //   //     [params.row.id]
            //   //   )
            //   // )
            // }
            // if (params.row.lcsw_account_status === '已开通') {
            children.push(
              commonButtonInTable(
                this,
                h,
                'success',
                i18n.t('pages_shops_index_1095'),
                this.shopCharge,
                [params.row.id]
              ),
              commonButtonInTable(
                this,
                h,
                'success',
                i18n.t('pages_shops_index_1096'),
                this.shopBuyableList,
                [params.row.id]
              )
            )
            // }
            return h('div', children)
          }
        }
      ],
      chargeFormLoading: true,
      charegModalShow: false,
      chargeForm: {},
      chargeRules: {
        sum: [{ required: true, message: i18n.t('pages_shops_index_1082') }]
      },
      shopTypesList: [{
        name: i18n.t('pages_shops_index_1085'),
        value: 'FreshSoftwareVersion'
      }, {
        name: i18n.t('pages_shops_index_1086'),
        value: 'FreshSoftwareFeature'
      }],
      shopVersionsList: [],
      shopFeaturesList: [],
      shopBuyableLoading: true,
      buyableModalShow: false,
      shopBuyable: {},
      buyableRules: {
        shopType: [{ required: true, message: i18n.t('pages_shops_index_1097') }],
        shopVersion: [{
          validator(rule, value, callback) {
            return vm.shopBuyable.shopType === 'FreshSoftwareVersion' ? !!value : true
          },
          required: true,
          message: i18n.t('pages_shops_index_1098')
        }],
        shopFeature: [{
          validator(rule, value, callback) {
            return vm.shopBuyable.shopType === 'FreshSoftwareFeature' ? !!value : true
          },
          required: true,
          message: i18n.t('pages_shops_index_1099')
        }],
      },
      countries: [{
        name: i18n.t('libs_value_list_121'),
        code: i18n.t('libs_value_list_121')
      }, {
        name: i18n.t('libs_value_list_122'),
        code: i18n.t('libs_value_list_122')
      }, {
        name: i18n.t('libs_value_list_126'),
        code: i18n.t('libs_value_list_126')
      }, {
        name: i18n.t('libs_value_list_127'),
        code: i18n.t('libs_value_list_127')
      }]
    }
  },
  async created() {
    this.changeQuery({ page: 1 })
    await this.index()
    this.current_shop_id = 0
    this.initialCheck()
    this.versionsIndex()
  },
  watch: {
    shop: {
      deep: true,
      immediate: true,
      async handler(val) {
        if (!val) return;
        const { province_zip_code, city_zip_code } = this.shop;
        this.fetchProvinces()
        const province = find(this.provinces, i => i.zip_code === province_zip_code);
        province && await this.fetchCities(province.id)
        const city = find(this.cities, i => i.zip_code === city_zip_code);
        city && this.fetchDistricts(city.id)
      }
    }
  },
  computed: {
    ...mapGetters('shop', ['shop', 'shops', 'meta', 'loading']),
    ...mapState('area', ['provinces', 'cities', 'districts']),
    ...mapGetters('fresh_software_version', ['fresh_software_versions']),
    qrCodeUrl() {
      return this.mini_code_type === 'weapp' ? this.mini_code_url : (this.qrCodeTemplate ? this.mini_code_template_url : this.mini_code_url)
    },
  },
  methods: {
    ...mapActions('shop', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy',
      // 'activate',
      // 'shop_reduce',
      'shop_charge',
      'shop_buyable_list'
    ]),
    ...mapActions('area', ['fetchProvinces', 'fetchCities', 'fetchDistricts']),
    ...mapActions('editor', ['getUserInfo', 'logout']),
    ...mapActions('permission', ['localSavePermissions']),
    ...mapActions('function_payment', { paymentCreate: 'create' }),
    ...mapActions('fresh_software_version', { versionsIndex: 'index' }),
    ...mapActions('delivery_setting', ['geocoder']),
    ...mapMutations('shop', ['changeQuery']),
    downloadImg,
    changePage(page) {
      this.changeQuery({ page: page })
      this.index()
    },
    getLatlng() {
      const { country, province_name, city_name, district_name, address } = this.shop
      if (country === i18n.t('libs_value_list_121') && (!province_name || !city_name || !district_name)) {
        return this.$Message.warning(i18n.t('pages_shops_index_1100'))
      }
      if (!address) {
        return this.$Message.warning(i18n.t('pages_shops_index_1101'))
      }

      this.geocoder({
        address: country === i18n.t('libs_value_list_121') ? province_name + city_name + district_name : country + address
      }).then(data => {
        const { status, result } = data
        // console.info('getLatlng', result, address_components, location)
        if (status !== 0 && !result) {
          return this.$Message.warning(i18n.t('pages_shops_index_1102'))
        }
        const { location: { lng, lat } } = result
        this.shop.longitude = lng
        this.shop.latitude = lat
      })
    },
    shop_select(shop) {
      // console.log('shop', shop);
      localStorage.setItem('SHOPID', shop.id)
      localStorage.setItem('SHOP_NAME', shop.name)
      localStorage.setItem('SHOP_TYPE', shop.shop_type)
      localStorage.setItem('IS_CLONED_MAIN_SHOP', shop.is_cloned_main_shop ? '1' : '0')
      localStorage.setItem('software_version_name', shop.software_version_name)
      this.index()
      this.getUserInfo().catch(e => {
        if (e.status === 422) {
          this.logout()
        }
      })
      this.localSavePermissions()
    },
    // shop_upgrade (id) {
    //   const { isChaibao } = this.$config
    //   if (isChaibao) {
    //     return this.$Message.warning('请联系代理商升级！')
    //   }
    //   this.clear()
    //   this.modalShow2 = true
    //   this.current_shop_id = id
    // },
    shopCharge(id) {
      this.current_shop_id = id
      this.chargeForm = {}
      this.charegModalShow = true
    },
    handleCharge() {
      this.$refs.chargeForm.validate(async (valid) => {
        if (valid) {
          const chargeUrl = await this.shop_charge({
            price: this.chargeForm.sum,
            shop_id: this.current_shop_id
          })
          this.charegModalShow = false
          if (isAndroidApp() === '1') {
            openUrlOnExternalBrowser(chargeUrl)
          } else {
            window.open(chargeUrl)
          }
        } else {
          this.chargeFormLoading = false
          this.$nextTick(() => (this.chargeFormLoading = true))
        }
      })
    },
    async shopBuyableList(id) {
      this.shopBuyable = {}
      this.shopVersionsList = []
      this.shopFeaturesList = []
      // let typeList = []
      const buyableList = await this.shop_buyable_list(id)
      buyableList.map(item => {
        item.buyable_type === 'FreshSoftwareFeature' ? this.shopFeaturesList.push(item) : this.shopVersionsList.push(item)
        // typeList.push(item.buyable_type)
      })
      // typeList = [...new Set(typeList)]

      this.current_shop_id = id
      this.buyableModalShow = true
    },
    handleChangeSoftware(item, value) {
      if (value) {
        if (item === 'type') {
          const list = value === 'FreshSoftwareVersion' ? this.shopVersionsList : this.shopFeaturesList
          const id = value === 'FreshSoftwareVersion' ? this.shopBuyable.shopVersion : this.shopBuyable.shopFeature
          if (id) {
            const info = find(list, { id }) || {}
            this.shopBuyable.price = info.price
            this.shopBuyable.duration = find(durationList, { value: info.duration }).label
            this.shopBuyable.quantity = info.quantity
          }
        } else {
          const list = item === 'version' ? this.shopVersionsList : this.shopFeaturesList
          const info = find(list, { id: value }) || {}
          this.shopBuyable.price = info.price
          this.shopBuyable.duration = find(durationList, { value: info.duration }).label
          this.shopBuyable.quantity = info.quantity
        }
      }
    },
    handleBuyable() {
      this.$refs.shopBuyable.validate(async (valid) => {
        if (valid) {
          const { shopType, shopVersion, shopFeature } = this.shopBuyable
          const buyableId = shopType === 'FreshSoftwareVersion' ? shopVersion : shopFeature
          const paymentResult = await this.paymentCreate({
            distributor_company_buyable_shop_id: buyableId,
            shop_id: this.current_shop_id
          })
          console.info(paymentResult)
          this.buyableModalShow = false
        } else {
          this.shopBuyableLoading = false
          this.$nextTick(() => (this.shopBuyableLoading = true))
        }
      })
    },
    // async handleSubmit () {
    //   this.activate({
    //     activation_code: this.shop.activation_code,
    //     id: this.current_shop_id
    //   })
    //   this.modalShow2 = false
    //   this.index()
    // },
    uploadedAvatar(url) {
      this.shop.avatar = url
    },
    handleShopUpdate() {
      this.$refs.shopUpdate.validate(async (valid) => {
        if (valid) {
          this.update(this.shop)
          this.modalShow = false
          this.index()
        } else {
          this.shopUpdateLoading = false
          this.$nextTick(() => (this.shopUpdateLoading = true))
        }
      })
    },
    onProvinceChange(zipCode) {
      const item = find(this.provinces, i => i.zip_code === zipCode);
      if (item && item.id) {
        this.fetchCities(item.id)
      }
      this.shop.city_zip_code = '';
      this.shop.district_zip_code = ''
    },
    onCityChange(zipCode) {
      const item = find(this.cities, i => i.zip_code === zipCode);
      if (item && item.id) {
        this.fetchDistricts(item.id)
      }
      this.shop.district_zip_code = ''
    },
    initialCheck() {
      const shopId = localStorage.getItem('SHOPID')
      const shops = this.shops || [];
      const shopIndex = shops.findIndex(i => i.id === +shopId)
      // console.info('initialCheck', shopId, shops, shopIndex)
      this.shop_select(shops[shopIndex !== -1 ? shopIndex : 0])
    }
  }
}
</script>

<style lang="less">
.shop_avatar {
  .el-upload {
    width: 100px;
    height: 100px;
    line-height: 100px;

    img,
    video {
      width: 100% !important;
      height: 100% !important;
    }
  }
}
</style>
